module.exports = __webpack_public_path__ + "img/Pusan1.fe73ac64.jpg";